// extracted by mini-css-extract-plugin
module.exports = {"actionsCell":"actionsCell__BiqJB","tooltip":"tooltip__oLmVD","button":"button__RIUIa","colorSuccess":"colorSuccess__-pV2E"};